import { useEffect } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
import { WELCOME } from "../../utils/strings";
import { useApi } from "../../hooks";
import {
  getAllBusinessCall,
  getBusinessProfileCall,
  getUserCall,
  getPartnerGymsCall,
} from "../../api/apiOperations";
import { Container, LeftContainer, Subtitle, Title } from "./styles";

interface DashboardHeaderProps {
  avatar: string;
}

const DashboardHeader = ({ avatar: _avatar }: DashboardHeaderProps) => {
  const today = new Date();
  const { userData, userMembershipStatus, partnerGymInfo } = useSelector(
    (state: RootState) => state.appData || {}
  );
  const { memberLoggedIn } = useSelector((state: RootState) => state.auth || {});
  const { businessId } = userMembershipStatus?.memberships?.active?.business || {};

  const { request: getAllBusinessCallReq } = useApi<any>({ apiFunc: getAllBusinessCall });
  const { request: getUserCallReq } = useApi<any>({ apiFunc: getUserCall });
  const { request: getBusinessProfileCallReq } = useApi<any>({ apiFunc: getBusinessProfileCall });
  const { request: getPartnerGymsCallReq } = useApi<any>({ apiFunc: getPartnerGymsCall });

  useEffect(() => {
    getUserCallReq();
    if (memberLoggedIn) getBusinessProfileCallReq(businessId);
    if (userData?.role === 'partner') getPartnerGymsCallReq();
  }, [businessId, memberLoggedIn, userData?.role]);

  useEffect(() => { getAllBusinessCallReq(); }, []);

  const isPartner = userData?.role === 'partner';
  const userLoaded = !!userData?.userId;
  // For partners, wait until the gym name is available before rendering
  const gymLoaded = !isPartner || !!partnerGymInfo?.name;
  const ready = userLoaded && gymLoaded;

  const displayName = isPartner
    ? partnerGymInfo?.name
    : userData?.firstName;

  return (
    <Container>
      {ready && (
        <LeftContainer>
          <Subtitle>{moment(today).format("MMMM Do YYYY")}</Subtitle>
          <Title>{WELCOME} {displayName}!</Title>
        </LeftContainer>
      )}
    </Container>
  );
};

export default DashboardHeader;
